$(document).ready(function() {
    // --- State Variables ---
    let bpm = 120;
    let isPlaying = false;
    let isAudioInitialized = false; // Flag to check if AudioContext is set up
    let audioContext;
    let soundBuffer;
    let timerWorker = new Worker('https://basscamp.com/cdn/shop/t/2/assets/metronome-timer-worker.js');

    // --- DOM Elements ---
    const $bpmSlider = $('#bpm-slider');
    const $bpmValue = $('#bpm-value');
    const $startStopBtn = $('#start-stop-btn');
    const $soundSelect = $('#sound-select');
    const $visualIndicator = $('#visual-indicator');

    // --- Web Audio API Setup ---
    function initAudio() {
        if (!isAudioInitialized) {
            console.log("Initializing Audio Context...");
            audioContext = new (window.AudioContext || window.webkitAudioContext)();
            isAudioInitialized = true;
        }
    }

    async function loadSound(url) {
        // We need an active audio context to decode sound
        if (!audioContext) {
            console.error("Audio Context not ready for loading sound.");
            return;
        }
        try {
            console.log(`Loading sound: ${url}`);
            const response = await fetch(url);
            const arrayBuffer = await response.arrayBuffer();
            soundBuffer = await audioContext.decodeAudioData(arrayBuffer);
            console.log("Sound loaded successfully.");
        } catch (error) {
            console.error(`Error loading sound: ${url}`, error);
            alert('Could not load the sound file. Please check the console for errors.');
        }
    }

    function playSound() {
        if (!soundBuffer || !audioContext) return;
        const source = audioContext.createBufferSource();
        source.buffer = soundBuffer;
        source.connect(audioContext.destination);
        source.start(audioContext.currentTime);
    }
    
    function visualBeat() {
        $visualIndicator.addClass('beat');
        setTimeout(() => {
            $visualIndicator.removeClass('beat');
        }, 100);
    }

    // --- Metronome Logic ---
    timerWorker.onmessage = function(e) {
        if (e.data === 'tick') {
            playSound();
            visualBeat();
        }
    };

    function start() {
        if (isPlaying) return;
        isPlaying = true;
        
        // Resume audio context if it was suspended
        if (audioContext.state === 'suspended') {
            audioContext.resume();
        }
        
        const interval = 60000 / bpm;
        timerWorker.postMessage({ command: 'start', interval: interval });
        
        $startStopBtn.text('STOP').addClass('playing');
    }

    function stop() {
        if (!isPlaying) return;
        isPlaying = false;
        timerWorker.postMessage({ command: 'stop' });
        $startStopBtn.text('START').removeClass('playing');
    }

    // --- Event Listeners ---
    $startStopBtn.on('click', async function() {
        // **THE FIX IS HERE**: Initialize and load sound on the FIRST click
        if (!isAudioInitialized) {
            initAudio();
            await loadSound($soundSelect.val()); // Wait for the first sound to load
        }

        if (isPlaying) {
            stop();
        } else {
            start();
        }
    });

    $bpmSlider.on('input', function() {
        bpm = $(this).val();
        $bpmValue.text(bpm);
        if (isPlaying) {
            const interval = 60000 / bpm;
            timerWorker.postMessage({ command: 'start', interval: interval });
        }
    });

    $soundSelect.on('change', function() {
        // Only try to load a new sound if the audio system is active
        if (isAudioInitialized) {
            loadSound($(this).val());
        }
    });
});